import React from "react"
import { Link } from "gatsby"

import Layout from "../../components/layout"
import SEO from "../../components/seo"
import Player from "../../components/player"

import { getFrameUrl } from "../../utils"
import {
  growPath,
  growFrameCount,
  growFrameWidth,
  growFrameHeight,
} from "../../constants"

const frames = []
for (let i = 0; i < growFrameCount; i++) {
  frames.push(getFrameUrl(growPath, i))
}

const InteractiveGrowPage = () => {
  return (
    <Layout>
      <SEO
        title="Grow interactive"
        description="An interactive web-app that allows you to build a galloping horse from a wire skeleton."
        bodyClass="tanBackground"
      />
      <div style={{ padding: "10px 0" }}>
        <Link to="/" style={{ color: "black" }}>
          back
        </Link>
      </div>
      <Player
        frames={frames}
        frameWidth={growFrameWidth}
        frameHeight={growFrameHeight}
      />
    </Layout>
  )
}

export default InteractiveGrowPage
